import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import type { toggleVariants } from '../toggle';
import type { OmitStylesComponentProps } from '../../types';

export const ToggleGroupContext = React.createContext<
    VariantProps<typeof toggleVariants>
>({
    size: 'default',
    variant: 'default',
});

const ToggleGroupVariants = cva(
    'flex items-center overflow-x-auto bg-gray-50 md:justify-center',
    {
        variants: {
            shape: {
                default:
                    'scrollbar-none rounded-full [&::-webkit-scrollbar]:hidden',
            },
            justify: {
                center: 'justify-center',
                start: 'justify-start',
            },
        },
        defaultVariants: {
            shape: 'default',
            justify: 'start',
        },
    },
);

export const ToggleGroup = React.forwardRef<
    React.ElementRef<typeof ToggleGroupPrimitive.Root>,
    OmitStylesComponentProps<typeof ToggleGroupPrimitive.Root> &
        VariantProps<typeof toggleVariants> &
        VariantProps<typeof ToggleGroupVariants>
>(({ variant, size, children, ...props }, ref) => (
    <ToggleGroupPrimitive.Root
        ref={ref}
        className={ToggleGroupVariants({ shape: 'default' })}
        {...props}
    >
        <ToggleGroupContext.Provider value={{ variant, size }}>
            {children}
        </ToggleGroupContext.Provider>
    </ToggleGroupPrimitive.Root>
));

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
